import React from 'react'
import { linksWrapping } from 'utils/links-wrapping'

const TextWithLinks = ({ text }) => {
  const config = [
    {
      reg: /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gi,
    },
    {
      reg: /([a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z0-9._-]+)/gi,
      type: 'mailto:',
    },
  ]
  return linksWrapping(text, config)
}

export default TextWithLinks;